<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 z-30">
    <nav class="h-full bg-white px-5 pt-10 text-lg">
      <div class="flex justify-between">
        <ul>
          <li>
            <a
              :href="`${baseURL}`"
              class="block px-8 py-3"
            >
              Expert Sourcing
            </a>
          </li>
          <li>
            <a
              :href="`${baseURL}/contract-manufacturing`"
              class="block px-8 py-3"
            >
              Contract Manufacturing
            </a>
          </li>
          <li>
            <router-link
              :to="{ name: 'Home' }"
              class="block px-8 py-3 bg-opacity-10 home-screen"
              :class="{'text-blue': currentView === 'Home' }"
            >
              Buy
            </router-link>
          </li>
          <li>
            <a
              :href="`${baseURL}/finance-page`"
              class="block px-8 py-3"
            >
              Financing
            </a>
          </li>
          <li>
            <div
              @mouseleave="showAboutOptions = false"
              @click="showAboutOptions = !showAboutOptions"
              class="flex px-8 py-3"
            >
              <span>About Us</span>
              <img src="@/assets/icons/chevronDown.svg" class="ml-4 w-4">
            </div>
            <transition name="slide-down">
              <ul v-if="showAboutOptions" class="slide-down">
                <li>
                  <a
                    :href="`${baseURL}/about`"
                    class="inline-block px-10 py-1"
                  >
                    Our Story
                  </a>
                </li>
                <li>
                  <a
                    :href="buyhiveHowToBuyLink"
                    class="inline-block px-10 py-1"
                  >
                    How to Buy
                  </a>
                </li>
              </ul>
            </transition>
          </li>
        </ul>
        <div>
          <img
            src="@/assets/icons/close.svg"
            class="text-green right-0 mr-3"
            @click="close"
          >
        </div>
      </div>
      <div class="px-8 py-10">
        <hr>
      </div>
      <div>
        <ul v-if="isUserLoggedIn && getUserAuthInfo.role === 'buyer'">
          <li>
            <router-link
              :to="{ name: 'My Account' }"
              class="block px-8 py-3 rounded-full bg-opacity-10"
              :class="{'bg-dark text-green': currentView === 'My Account'}"
            >
              Account Settings
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'My Orders' }"
              class="block px-8 py-3 rounded-full bg-opacity-10"
              :class="{'bg-dark text-green': currentView === 'My Orders'}"
            >
              My Orders
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'Change Password' }"
              class="block px-8 py-3 rounded-full bg-opacity-10"
              :class="{'bg-dark text-green': currentView === 'Change Password'}"
            >
              Change Password
            </router-link>
          </li>
          <li @click="signOut">
            <router-link
              :to="{ name: 'Home' }"
              class="block px-8 py-3"
            >
              Logout
            </router-link>
          </li>
        </ul>
        <ul v-if="isUserLoggedIn && getUserAuthInfo.role === 'freelancer'">
          <li @click="signOut">
            <router-link
              :to="{ name: 'Home' }"
              class="block px-8 py-3"
            >
              Logout
            </router-link>
          </li>
        </ul>
        <div v-if="!isUserLoggedIn" class="px-8">
          <button
            class="inline-flex items-center justify-center border rounded-full border-blue px-6 text-blue py-2 w-40 mb-3 align-top md:mr-4"
            @click="close(), storeCurrentRoute(), openSignUpSelection()"
          >
            <span class="ml-2">Register</span>
          </button>
          <button
            class="inline-flex items-center justify-center border rounded-full border-green px-6 text-green py-2 w-40"
            @click="close(), storeCurrentRoute(), openLoginSelection()"
          >
            <img src="@/assets/icons/user.svg">
            <span class="ml-2">Sign In</span>
          </button>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'MobileMenu',
  data() {
    return {
      showAboutOptions: false,
      buyhiveHowToBuyLink: process.env.VUE_APP_BUYHIVE_HOW_TO_BUY,
      freelancerURL: process.env.VUE_APP_FREELANCER_HOME_PATH
    }
  },
  computed: {
    ...mapGetters ([
      'isUserLoggedIn',
      'getUserAuthInfo'
    ]),
    baseURL() {
      return process.env.VUE_APP_SERVER_BASE_URL
    },
    currentView() {
      return this.$route.name
    }
  },
  methods: {
    ...mapActions ([
      'logout',
      'resetUserCart',
      'setAuthTabModal',
      'openSignupSelectionModal',
      'openLoginSelectionModal'

    ]),
    storeCurrentRoute() {
      localStorage.setItem('previousUrl', window.location.href)
    },
    openSignUpSelection() {
      this.$router.push({name: 'SignupSelection'})
    },
    openLoginSelection() {
      this.$router.push({name: 'LoginSelection'})
    },
    close() {
      this.$emit('close')
    },
    async signOut() {
      const result = await this.logout()
      if (result) {
        this.resetUserCart()
        this.close()
      }
    },
    closeNavAndOpenAuthModal(tab) {
      this.setAuthTabModal(tab)
      this.close()
    }
  }
}
</script>
<style>
.home-screen {
  color: #00B2C9;
  font-weight: 600;
}
</style>
